import { supabase } from './supabase'

// Insight sul corridore (vedi sql/20261012210000_rider_insights.sql): cosa e' successo quando l'hai scelto tu e com'e' la sua forma.
// Si leggono una volta per tappa e corridore e si tengono in cache per la sessione.
const cache = new Map()
const key = (userId, idStage, idRider) => `${userId}|${idStage}|${idRider}`
const CHUNK = 250

export async function loadRiderInsights(userId, idStage, riderIds) {
  const ids = [...new Set(riderIds)].filter(Boolean)
  const missing = ids.filter(id => !cache.has(key(userId, idStage, id)))
  for (let i = 0; i < missing.length; i += CHUNK) {
    const part = missing.slice(i, i + CHUNK)
    const { data, error } = await supabase.rpc('fn_rider_insights', { p_id_user: userId, p_id_stage: idStage, p_riders: part })
    if (error) throw error
    ;(data ?? []).forEach(r => cache.set(key(userId, idStage, r.id_rider), r))
  }
  return Object.fromEntries(ids.map(id => [id, cache.get(key(userId, idStage, id)) ?? null]))
}

// Secondi -> "+m:ss" / "+h:mm:ss" (vuoto se zero)
export function fmtSeconds(sec) {
  const s = Math.round(Number(sec))
  if (!s || s <= 0) return ''
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60
  const pad = (n) => String(n).padStart(2, '0')
  return h > 0 ? `+${h}:${pad(m)}:${pad(ss)}` : `+${m}:${pad(ss)}`
}
